import React from 'react';

export const DEFAULT_PART_B_SUBJECTS = [
  { activity: 'G. K.', term1: 'A', term2: 'A' },
  { activity: 'Computer', term1: 'A+', term2: 'A+' },
  { activity: 'Art & Craft', term1: 'A', term2: 'A' },
  { activity: 'Value Education', term1: 'A+', term2: 'A+' },
  { activity: 'Physical Education', term1: 'A', term2: 'A' }
];

const CoScholasticSection = ({ coScholasticList = [], title = 'B. Co-Scholastic Area', primaryColor = '#1e3a8a' }) => {
  const list = (coScholasticList && coScholasticList.length > 0) ? coScholasticList : DEFAULT_PART_B_SUBJECTS;

  return (
    <div style={{ marginBottom: '16px', background: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', overflow: 'hidden' }}>
      <div style={{ background: primaryColor, color: '#ffffff', padding: '6px 12px', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        {title}
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10.5px' }}>
        <thead>
          <tr style={{ background: '#f1f5f9', borderBottom: '1px solid #cbd5e1', color: '#334155' }}>
            <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: '700', borderRight: '1px solid #cbd5e1' }}>Subject</th>
            <th style={{ padding: '6px 10px', textAlign: 'center', width: '25%', fontWeight: '700', borderRight: '1px solid #cbd5e1' }}>First Semester</th>
            <th style={{ padding: '6px 10px', textAlign: 'center', width: '25%', fontWeight: '700' }}>Second Semester</th>
          </tr>
        </thead>
        <tbody>
          {list.map((row, idx) => (
            <tr key={idx} style={{ borderBottom: '1px solid #e2e8f0', background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
              <td style={{ padding: '6px 10px', fontWeight: '600', borderRight: '1px solid #e2e8f0', color: '#1e293b' }}>
                {row.activity || row.subject || row.name || '—'}
              </td>
              <td style={{ padding: '6px 10px', textAlign: 'center', fontWeight: '700', color: primaryColor, borderRight: '1px solid #e2e8f0' }}>
                {row.term1 || row.sem1 || row.firstSemester || row.grade || '—'}
              </td>
              <td style={{ padding: '6px 10px', textAlign: 'center', fontWeight: '700', color: primaryColor }}>
                {row.term2 || row.sem2 || row.secondSemester || row.grade || '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CoScholasticSection;
